var data = new Object()

RawLensData = function(){
	
this.to_LENS_LABEL_SOFLENS_DAILY_MULTILINE="SofLens®\ndaily disposable toric";

this.to_LENS_LABEL_SOFLENS_DAILY="SofLens® daily disposable toric";

this.to_LENS_SOFLENS_DAILY="sof_lens_daily";

this.to_LENS_LABEL_SOFLENS="SofLens® Toric";

this.to_LENS_SOFLENS="sof_lens_toric";

this.to_LENS_LABEL_PURE_2HD_MULTILINE="PureVision®2 HD\nfor Astigmatism";

this.to_LENS_LABEL_PURE_2HD="PureVision®2 HD for Astigmatism";

this.to_LENS_PURE_2HD="pure_vision_2hd";

this.to_LENS_LABEL_PURE="Biotrue®ONEday for Astigmatism";

this.to_LENS_PURE="biotrueoneday_f_a";

this.to_ERROR="eoorE"

this.to_THEORETICAL_POWER="eoorE"

this.DEFAULT_LENS_NAME = this.LENS_LABEL_PURE_2HD;

this.DEFAULT_LENS = this.LENS_PURE_2HD;

this.AVAILABLE_LENS_LABELS_MULTILINE =[this.to_LENS_LABEL_PURE_2HD_MULTILINE, this.to_LENS_LABEL_PURE, this.to_LENS_LABEL_SOFLENS, this.to_LENS_LABEL_SOFLENS_DAILY_MULTILINE];

this.AVAILABLE_LENS_LABELS=[this.to_LENS_LABEL_PURE_2HD, this.to_LENS_LABEL_PURE, this.to_LENS_LABEL_SOFLENS, this.to_LENS_LABEL_SOFLENS_DAILY];

this.AVAILABLE_LENSES=[this.to_LENS_PURE_2HD, this.to_LENS_PURE, this.to_LENS_SOFLENS, this.to_LENS_SOFLENS_DAILY];

this.DEFAULT_BVD=13;

this.DEFAULT_ANGLE=0;

this.CYL_THRESHOLD=0.5;

this.MINIMUM_CYLINDRIACL_TORIC=-0.5;

this.MAXIMUM_SPERICAL_TORIC=0.5;

this.MAXIMUM_CYLINDER_TORIC=0.5;

this.MAX_AXIS_TORIC=180;

this.GENERIC_SPERE_VALUES = [-20, -19.75, -19.5, -19.25, -19, -18.75, -18.5, -18.25, -18, -17.75, -17.5, -17.25, -17, -16.75, -16.5, -16.25, -16, -15.75, -15.5, -15.25, -15, -14.75, -14.5, -14.25, -14, -13.75, -13.5, -13.25, -13, -12.75, -12.5, -12.25, -12, -11.75, -11.5, -11.25, -11, -10.75, -10.5, -10.25, -10, -9.75, -9.5, -9.25, -9, -8.75, -8.5, -8.25, -8, -7.75, -7.5, -7.25, -7, -6.75, -6.5, -6.25, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.25, 4.5, 4.75, 5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20];
this.GENERIC_CYLINDER_VALUES = [-10, -9.75, -9.5, -9.25, -9, -8.75, -8.5, -8.25, -8, -7.75, -7.5, -7.25, -7, -6.75, -6.5, -6.25, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0];
this.PV_SPHERE_VALUES = [-9, -8.5, -8, -7.5, -7, -6.5, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.25, 4.5, 4.75, 5, 5.25, 5.5, 5.75, 6];
this.PV_CYLINDER_VALUES = [-2.25, -1.75, -1.25, -0.75];
this.PV_AXIS_VALUES = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180];
this.PV_2HD_SPHERE_VALUES = [-9, -8.5, -8, -7.5, -7, -6.5, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.25, 4.5, 4.75, 5, 5.25, 5.5, 5.75, 6];
this.PV_2HD_CYLINDER_VALUES = [-2.25, -1.75, -1.25, -0.75];
this.PV_2HD_AXIS_VALUES = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180];
this.SLT_SPHERE_VALUES = [-9, -8.5, -8, -7.5, -7, -6.5, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.25, 4.5, 4.75, 5, 5.25, 5.5, 5.75, 6];
this.SLT_CYLINDER_VALUES = [-2.75, -2.25, -1.75, -1.25, -0.75];
this.SLT_AXIS_VALUES = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180];
this.SLD_SPHERE_VALUES = [-9, -8.5, -8, -7.5, -7, -6.5, -6, -5.75, -5.5, -5.25, -5, -4.75, -4.5, -4.25, -4, -3.75, -3.5, -3.25, -3, -2.75, -2.5, -2.25, -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0];
this.SLD_CYLINDER_VALUES = [-1.75, -1.25, -0.75];
this.SLD_AXIS_VALUES = [0, 20, 90, 160, 180];
	
}

data.RawLensData = new RawLensData()


data.ToricModel = {
	

       ANGLE_STEPS_MED : 5,

       ANGLE_STEPS_SML : 1,

       DEFAULT_BVD : 13,

       spectacleRefraction: new RefractionData(),

       results:data.Results,

       trialValue: new RefractionData(),

       userAxisAngle : 0,

       selectedLens : data.RawLensData.DEFAULT_LENS,

        userBVD : 13,

        angleSteps : 1


}

data.Results = {

     
	trialResults: [],
	recommendResults: []
 
}





